var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { attrs: { title: "Account Health" } }, [
    _c("div", { staticClass: "text-gray-600 text-sm mb-4" }, [
      _vm._v("An overview of your platform health")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "space-y-2" }, [
      _c("div", { staticClass: "flex items-center gap-2" }, [
        _c("span", { staticClass: "text-green-600 text-xl" }, [_vm._v("♥")]),
        _vm._v(" "),
        _c("span", { staticClass: "font-semibold text-green-600" }, [
          _vm._v("Healthy")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "text-gray-500 text-xs ml-2" }, [
          _vm._v("AWS-style overview")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex items-center gap-2" }, [
        _c("span", { staticClass: "text-green-700 font-bold" }, [_vm._v("OK")]),
        _vm._v(" "),
        _c("span", { staticClass: "font-semibold" }, [
          _vm._v("API Responsiveness")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "text-gray-500 text-xs ml-2" }, [
          _vm._v("All endpoints are responsive")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex items-center gap-2" }, [
        _c("span", { staticClass: "text-green-600 font-bold" }, [
          _vm._v("Healthy")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "font-semibold" }, [_vm._v("Backup Status")]),
        _vm._v(" "),
        _c("span", { staticClass: "text-gray-500 text-xs ml-2" }, [
          _vm._v("Backups are running on schedule")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex items-center gap-2" }, [
        _c("span", { staticClass: "text-blue-600 font-bold" }, [
          _vm._v("Normal")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "font-semibold" }, [
          _vm._v("Service Quotas")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "text-gray-500 text-xs ml-2" }, [
          _vm._v("No quota limits exceeded")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex items-center gap-2" }, [
        _c("span", { staticClass: "text-yellow-500 font-bold" }, [
          _vm._v("Low")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "font-semibold" }, [_vm._v("Error Rate")]),
        _vm._v(" "),
        _c("span", { staticClass: "text-gray-500 text-xs ml-2" }, [
          _vm._v("Minimal errors detected")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32897ffd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32897ffd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/StatCards/ReccomendationsRow/HealthCard.vue
// module id = null
// module chunks = 